namespace $.$$ {
	export class $shm_projects_digest_view extends $.$shm_projects_digest_view {
		digest(): $shm_projects_digest_record | null { return null }
		notes() { return this.digest()?.notes ?? null }
		updated_text() {
			const digest = this.digest()
			if( !digest ) return ''
			if( !digest.notes ) return ''
			const date = new Date( digest.notes.generated_at ).toLocaleString( 'ru-RU', {
				timeZone: 'Europe/Moscow', dateStyle: 'short', timeStyle: 'short',
			} )
			return `Обновлено ${date} МСК`
		}
		content_text() {
			const notes = this.notes()
			return notes ? notes[ this.Notes().audience() as 'user' | 'technical' | 'product' | 'executive' ] : 'Итоги ещё не подготовлены.'
		}
	}
}
